import { useMemo } from "react";

import { useStore } from "../../stores/StoreContext";
import { ThreadService } from "../LogicServices/ThreadService";

export function useThreadService(): ThreadService {
  const storeContext = useStore();
  return useMemo(() => new ThreadService(storeContext), [storeContext]);
}
